export const getParentHeaderCellStyles = () => {
  return {
    textAlign: 'center',
    background: '#595959',
    borderTop: '1px solid #808080',
    borderRight: '1px solid #808080',
    borderBottom: '1px solid #808080',
    borderLeft: '1px solid #808080',
  };
};

export const getHeaderCellStyles = () => {
  return {
    textAlign: 'right',
  };
};

export const getFooterCellStyles = () => {
  return {
    textAlign: 'right',
  };
};

export const getCellStyles = () => {
  return {
    textAlign: 'right',
  };
};
